import { ILocation } from '../types/location';

export const SESSION_REGION_ID_COOKIE_KEY = 'session_region_id';
export const FOREVER_REGION_ID_COOKIE_KEY = 'forever_region_id';

export const MOSCOW_REGION_ID = 1;
export const MOSCOW_WITH_AREA_REGION_ID = -1;
export const MOSCOW_AREA_REGION_ID = 4593;
export const ST_PETERSBURG_REGION_ID = 2;
export const ST_PETERSBURG_WITH_AREA_REGION_ID = -2;
export const ST_PETERSBURG_AREA_REGION_ID = 4588;

export const MOSCOW_REGION_NAME = 'Москва';
export const MOSCOW_AREA_REGION_NAME = 'Московская область';
export const ST_PETERSBURG_REGION_NAME = 'Санкт-Петербург';
export const ST_PETERSBURG_AREA_REGION_NAME = 'Ленинградская область';

export const DEFAULT_MOSCOW_REGION: ILocation = {
  displayName: 'Москва',
  id: 1,
  mainTownId: null,
  name: 'Москва',
  parentId: null,
};
